<template>
    <div class="self-center btn btn-logo" @click="goBack"  title="Go Back">
        <div class="flex items-center">
            <!-- <div><i class="fas fa-arrow-left"></i></div> -->
            <div class="w-4 h-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                </svg>
            </div>

            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['levels', 'history'],
        data() {
            return {
                back: this.levels*1 || 1,
                normal: this.history ? true : false,
            }
        },
        mounted() {
            // console.log('Component mounted.')
            String.prototype.nthLastIndexOf = function(searchString, n){
                var url = this;
                if(url === null) {
                    return -1;
                }
                if(!n || isNaN(n) || n <= 1){
                    return url.lastIndexOf(searchString);
                }
                n--;
                return url.lastIndexOf(searchString, url.nthLastIndexOf(searchString, n) - 1);
            }
        },
        methods: {
            goBack(){
                if (this.normal) {
                    window.history.back();
                } else {
                    var t = window.location.href;
                    t = t.substr(0, t.nthLastIndexOf("/", this.back));
                    window.location.href = t;
                }
            }

        }
    }
</script>
